import { Profile } from '../../../lib/phinxapp/profiles/types';
import { initialMenu } from './initialMenu';
import { FullScreenLayout } from "../../../application/layouts";

export const initialProfile: Profile = {
  name: 'initial',
  component: FullScreenLayout,
  menu: initialMenu,
};
